export default __webpack_public_path__ + "static/media/logo_postal_dark.d98fad74.png";